import React from 'react'
import './Footer.scss'
const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className='footer'>
      <div className="container ">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="footer__links text-center">
                        <a href="mailto:paradzaigwira@gmail.com"><i className="fas fa-envelope"></i></a>
                        <a href="https://wa.me/263779595650?text=Hello%20Mr%20Gwira%2C%20We%20are%20interested%20with%20your%20Profile%2C%20we%20would%20like%20to%20hire%20you" target="_blank" rel="noreferrer"><i className="fa-brands fa-whatsapp"></i></a>
                        <a href="https://github.com/PRedemption" target="_blank" rel="noreferrer"><i className="fa-brands fa-github"></i></a>
                        <a href="https://twitter.com/frahanitrate" target="_blank" rel="noreferrer"><i className="fa-brands fa-twitter"></i></a>
                        <a href="https://www.facebook.com/paradzai.gwira" target="_blank" rel="noreferrer"><i className="fa-brands fa-facebook-f"></i></a>
                        <a href="linkedin.com/in/paradzai-gwira-216169194" target="_blank" rel="noreferrer"><i className="fa-brands fa-linkedin-in"></i></a>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12 text-center">
                    <p className="footer__copy">Copyright &copy; {year} Redemption Paradzai Gwira</p>
                </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer